// extracted by mini-css-extract-plugin
module.exports = {"User":"UserButton_User__sinRI","Avatar":"UserButton_Avatar__z3FeD","ForHireBadge":"UserButton_ForHireBadge__Mehzu","Name":"UserButton_Name__f6lP2"};